import { render, staticRenderFns } from "./wx-launch-weapp.vue?vue&type=template&id=8d1c9388&scoped=true"
import script from "./wx-launch-weapp.vue?vue&type=script&lang=js"
export * from "./wx-launch-weapp.vue?vue&type=script&lang=js"
import style0 from "./wx-launch-weapp.vue?vue&type=style&index=0&id=8d1c9388&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1c9388",
  null
  
)

export default component.exports